import axios from "axios";
import Vue from "vue";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_URL,
});

// axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
// axiosInstance.defaults.headers.post['responseType'] = 'json';
// axiosInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

axiosInstance.interceptors.request.use(
  function (config) {
    const token = window.sessionStorage.token;
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const api = {
  get(endpoint) {
    return axiosInstance.get(endpoint);
  },
  post(endpoint, body) {
    return axiosInstance.post(endpoint, body);
  },
  put(endpoint, body) {
    return axiosInstance.put(endpoint, body);
  },
  delete(endpoint, body) {
    return axiosInstance.delete(endpoint, body);
  },
  login(body) {
    return axiosInstance.post("/login", body);
  },
  registrarAcesso(body) {
    return axiosInstance.post("/login/acessos", body);
  },
  validate() {
    const token = sessionStorage.token;
    return axiosInstance.get(
      "/login/validateToken?authToken=" + token.replace("Bearer ", "")
    );
  },
};

if (sessionStorage.userData) {
  Vue.prototype.$user = JSON.parse(sessionStorage.userData);
}
axiosInstance.interceptors.response.use((response) => {
  if (response.status == 401) {
    this.$store.dispatch("LOGOUT");
    this.$router.push({ name: "login" });
  }
  if (response.status == 429) {
    this.$store.dispatch("LOGOUT");
    this.$router.push({ name: "login" });
  }
  return response;
});
Vue.prototype.$http = api;
